import React, {
  useLayoutEffect,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import { Container, Row, Col, Image, Button, ListGroup } from "react-bootstrap";
import src from "../../assets/admin-bg.jpg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { showAlert } from "../../components/common/showAlert";
import { useReactToPrint } from "react-to-print";
import { useSelector, useDispatch } from "react-redux";
import { myAccountActions, sendPhotosActions, archivedActions } from "../../_store";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import translations from "../../config/TranslateFile.jsx";
import { sendEcardsActions } from "../../_store/sendEcards.slice.js";
import { CreateEventLogTextFileForInbox, EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import CustomPhoto from "../../components/Image/ZoomRotateImage.jsx";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import CustomEcard from "../../components/Image/CustomEcard.jsx";

const EcardViewer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = translations();
  const dispatch = useDispatch();
  const componentRef = useRef(); // Ref used for print - Purchase History Table Current Row.
  const eCardId = location.state?.eCardId; // Access the photo data
  //   const photo = useSelector((state) => state.sendPhotos.LoadPhotosDetailsResponse);
  const eCard = useSelector((state) => state.sendEcards.EcardListData);
  const MsgPhotoStatusResponse = useSelector(
    (state) => state.sendPhotos.CheckingMsgPhotoStatusResponse
  );
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const CheckInmateConnectionStatus = useSelector(
    (state) => state.sendPhotos.CheckInmateConnectionStatus
  );
  const [disabledItems, setDisabledItems] = useState({
    newPhotos: false,
    photosHistory: false,
    purchaseCredits: false,
    cancelConnection: false,
    printPhoto: false,
  });
  const UserID = getStoredValue("userID");
  const [rotation, setRotation] = useState(0);
  const [loading, setLoading] = useState(false);
  //   const imagePath = photo?.PhotoAttachPath?.startsWith('/')
  //     ? photo?.PhotoAttachPath
  //     : `/${photo?.PhotoAttachPath}`;
  const imageUrl = `${process.env.REACT_APP_API_IMAGE_URL}${eCardId?.EcardFilePath}`; // Use the base64 data when PhotoBinarySave is 1

  //   const imageUrl = `data:image/jpeg;base64,${eCard?.EcardBase64}`
  const [imageURL, setImageURL] = useState(null);

  const myAccountDetails = useSelector(
    (state) => state.myAccount.LoadPublicUserDetails
  );
  const UpdateInmateConnectionResponse = useSelector(
    (state) => state.sendPhotos.UpdateInmateConnection
  );
  const [isPrintData, setIsPrintData] = useState(false);

  const [photos, setPhoto] = useState(null); // State to store the selected photo data
  const [isNewPhotoConfirmation, setIsNewPhotoConfirmation] = useState(false);
  const [isPurchaseHistoryConfirm, setIsPurchaseHistoryConfirm] =
    useState(false);
  const [isConnectionConfirm, setIsConnectionConfirm] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [inmateID, setInmateID] = useState("");
  const [isCreditamountModal, setisCreditamountModal] = useState(false);
  const [msgCreditamount, setMsgCreditamount] = useState("");


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleHistoryClick = (InmateID, User) => {
    const updatedFindEcards = {
      ...location.state?.findEcards, // Spread current `findEcards` to retain existing values
      InmateID: InmateID,
      userID: parseInt(UserID),
    };
    navigate("/public/SentE-Cards"
      , {
        state: { findEcards: updatedFindEcards, IsUser: User, activeTab: location.state?.activeTab },
      }
    );
    storeCurrentRoute("/public/SentE-Cards");
  };

  const handleClickSearch = () => {
    navigate("/public/SentE-Cards", {
      state: { findEcards: location.state?.findEcards, activeTab: location.state?.activeTab },
    });
    storeCurrentRoute("/public/SentE-Cards");
  };

  const handleWriteMessage = (InmateId) => {
    setIsNewPhotoConfirmation(true);
    setInmateID(InmateId);
    const infoMessage = "Clicked on New E-Cards ";
    const redirectURL = "---";
    const Status = "Shows YES or No Confirmation popup";
    const Response = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };

  useEffect(() => {
    const publicUserId = getStoredValue("userID");
    if (publicUserId) {
      dispatch(
        archivedActions.PULoginUnreadNotificationCount({ publicUserId })
      );
    }
  }, []);

  useEffect(() => {
    if (eCardId) {
      setDisabledItems({
        newPhotos: false,
        photosHistory: false,
        purchaseCredits: false,
        cancelConnection: false,
        printPhoto: false,
      });

      LoadEcardDetails();
    }
  }, [eCardId, dispatch]);

  //  useLayoutEffect(() => {
  //    if (eCard?.length === undefined) {
  //      if (eCard?.IsAllowSendReply !== 1) {
  //        setDisabledItems({
  //          newPhotos: true,
  //          photosHistory: false,
  //          purchaseCredits: true,
  //          cancelConnection: true,
  //          printPhoto: false,
  //        });
  //        if (eCard?.ActiveStatus !== 1) {
  //          setDisabledItems((prevState) => ({
  //            ...prevState, // Preserve previous state
  //            newPhotos: true,
  //            purchaseCredits: true,
  //            cancelConnection: true,
  //          }));
  //        } else if (eCard?.InmateStatus === 0) {
  //          let IsCancelConnection = true;
  //          if (eCard?.ConnectionStatusID === 2) {
  //            IsCancelConnection = false;
  //          } else {
  //            IsCancelConnection = true;
  //          }
  //          setDisabledItems((prevState) => ({
  //            ...prevState, // Preserve previous state
  //            newPhotos: true,
  //            purchaseCredits: true,
  //            cancelConnection: IsCancelConnection,
  //          }));
  // } else if (
  //          eCard?.IsAllowSendReply != 1 &&
  //          eCard?.ConnectionStatusID == 2
  //        ) {
  //          setDisabledItems((prevState) => ({
  //            ...prevState, // Preserve previous state
  //            purchaseCredits: false,
  //            cancelConnection: false,
  // }));
  //        }
  //      } else {
  //        setDisabledItems((prevState) => ({
  //          ...prevState, // Preserve previous state
  //          newPhotos: false,
  //          purchaseCredits: false,
  //          cancelConnection: false,
  //        }));
  //      }

  //      if (eCard?.Blocked === 1) {
  //        setDisabledItems((prevState) => ({
  //          ...prevState,
  //          newPhotos: true,
  //          purchaseCredits: true,
  //        }));
  //      } else if (eCard?.PhotoLockdown === 1 || eCard?.PhotoPODAccess === 0) {
  //        setDisabledItems((prevState) => ({
  //          ...prevState, // Preserve previous state
  //          newPhotos: true, // Update only the newPhotos property
  //        }));
  //      }
  //    }
  //  }, [eCard]);

  useEffect(() => {
    if (!eCardId) return;

    let updatedState = {
      newPhotos: false,
      photosHistory: false,
      purchaseCredits: false,
      cancelConnection: false,
      printPhoto: false,
    };

    if (eCardId.IsAllowSendReply !== 1) {
      updatedState.newPhotos = true;
      updatedState.purchaseCredits = true;
      updatedState.cancelConnection = true;

      if (eCardId.ActiveStatus !== 1) {
        updatedState.cancelConnection = true;
      } else if (eCardId.InmateStatus === 0) {
        updatedState.cancelConnection = eCardId.ConnectionStatusID !== 2;
      } else if (eCardId.IsAllowSendReply !== 1 && eCardId.ConnectionStatusID === 2) {
        updatedState.purchaseCredits = false;
        updatedState.cancelConnection = false;
      }
    }

    if (eCardId.Blocked === 1) {
      updatedState.newPhotos = true;
      updatedState.purchaseCredits = true;
    } else if (eCardId.PhotoLockdown === 1 || eCardId.PhotoPODAccess === 0) {
      updatedState.newPhotos = true;
    }

    setDisabledItems(updatedState);
  }, [eCardId]);


  useEffect(() => {
    if (MsgPhotoStatusResponse) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: false,
            photosHistory: false,
            purchaseCredits: false,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: false,
            photosHistory: false,
            purchaseCredits: false,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: false,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            // If success response (result = 0), redirect
            setStoredValue("InmateID", inmateID);
            navigate("/public/PurchaseCredits", {
              state: { previousPath: location.pathname },
            });
            storeCurrentRoute("/public/PurchaseCredits");
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

          }
          break;
      }
      handleCancelPurchaseHist();
      LoadEcardDetails();
    }
  }, [MsgPhotoStatusResponse]);

  // const LoadEcardDetails = () => {
  //   showLoader();
  //   dispatch(sendEcardsActions.LoadEcardsDetails({ eCardId })).then(
  //     (response) => {
  //       let imageURL = response?.payload?.[0]?.EcardBase64;
  //       setImageURL(imageURL);
  //     }
  //   );
  //   hideLoader();
  // };
  const LoadEcardDetails = () => {
    showLoader();

    dispatch(
      sendEcardsActions.LoadSendEcardList({
        publicUserID: eCardId?.PublicUserId,
        inmateID: eCardId?.InmateId,
        ecardSubject: "",
        fromDate: "",
        toDate: "",
        status: 0,
        pageNo: 1,
        rowCountPerPage: 10,
        sortBy: "",
      })
    )
      .then((response) => {
        const imageURL = response?.payload?.[0]?.EcardFilePath;
        setImageURL(imageURL);
      })
      .catch((error) => {
        console.error("Failed to load ecard details:", error);
      })
      .finally(() => {
        hideLoader(); // Ensure loader is hidden after dispatch finishes
      });
    if (eCardId?.ReadStaus === "Unread" && eCardId?.Sender == "Inmate") {
      dispatch(
        sendEcardsActions.LoadUpdateunreadPUEcardDetails({
          eCardId: eCardId?.CardId,
          inmateId: eCardId?.InmateId,
        })
      ).catch((error) => {
        console.error("Failed to update unread ecard status:", error);
      });
    }
    if (eCardId?.ReadStaus !== "Read") {
      const publicUserId = getStoredValue("userID");
      if (publicUserId) {
        dispatch(
          archivedActions.PULoginUnreadNotificationCount({ publicUserId })
        );
      }
    }
  };


  const handleClickRedirectPurchaseridet = () => {
    showLoader();
    // dispatch(
    //   sendPhotosActions.CheckingMsgPhotoStatus({
    //     addFormData: { UserID: UserID, PhotoInmateID: inmateID },
    //   })
    // );
    setStoredValue("InmateID", inmateID);
    navigate("/public/PurchaseCredits", {
      state: { previousPath: location.pathname },
    });
    storeCurrentRoute("/public/PurchaseCredits");
    hideLoader();
  };

  // Purchase Histroy Table - (Particular row print option)
  const handlePrintShow = () => {
    setPhoto(photos); // Set the photo data to state
    setIsPrintData(true); // Show the print content
    setTimeout(() => {
      handlePrints(); // Trigger print after a short delay to allow rendering
    }, 10);
    const infoMessage = "E-Cards Clicked on Print option";
    const redirectURL = "---";
    const Status = "---";
    const Response = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
            @page {
              // size: 4in 5in;
               size: portrait;
              margin: 0 !important;
              padding: 0 !important;
            }
          }`,

    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  // result for photos status
  useEffect(() => {
    if (CheckInmateConnectionStatus != null) {
      const InmateDetails = CheckInmateConnectionStatus;
      if (InmateDetails.length > 0) {
        setIsNewPhotoConfirmation(false);
        if (InmateDetails[0].ConnectionStatusID == 3 || InmateDetails[0].ConnectionStatusID == 4 || InmateDetails[0].ConnectionStatusID == 5) {
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].IsPhotoAccess == 0 || InmateDetails[0].PhotoAccess == 0) {
          setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: false,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].ActiveStatus == 0) {
          setPaymentMsg(currentLang?.ECardPopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].Blocked == 1) {
          setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: true,
            cancelConnection: true,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else if (InmateDetails[0].PhotoLockdown == 1 || InmateDetails[0].PhotoPODAccess == 0) {
          setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
          setIsPaymentMsg(true);
          setDisabledItems({
            newPhotos: true,
            photosHistory: false,
            purchaseCredits: false,
            cancelConnection: false,
            printPhoto: false,
          });
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
        else {
          navigate("/public/WriteMessage", {
            state: { PhotoInmateID: inmateID },
          });
          storeCurrentRoute("/public/WriteMessage");
          dispatch(sendPhotosActions.clearInmateConnectionStatusResponse());
        }
      }
    }
  }, [CheckInmateConnectionStatus, dispatch]);

  useEffect(() => {
    if (UpdateInmateConnectionResponse === 1) {
      dispatch(sendPhotosActions.clearEmailResponse());
      let updatedState = {
        newPhotos: true,
        photosHistory: false,
        purchaseCredits: true,
        cancelConnection: true,
        printPhoto: false,
      };
      setDisabledItems(updatedState);
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.ECardPopContent?.Request_Cancelled_Success,
        type: "success",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "Request Canceled successfully";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      LoadEcardDetails();
    } else if (UpdateInmateConnectionResponse === -1) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Operation_Failed,
        type: "error",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "Operation Failed";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    } else if (UpdateInmateConnectionResponse === -2) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Rejected_ByInmate,
        type: "warning",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "Current Connection Status is Not Request Rejected By Inmate";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      LoadEcardDetails();
    } else if (UpdateInmateConnectionResponse === -3) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Accept_ByInmate,
        type: "warning",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "Current Connection Status is Not Request Accept By Inmate";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      LoadEcardDetails();
    } else if (UpdateInmateConnectionResponse === -4) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Rejected_ByPU,
        type: "warning",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "Current Connection Status is Not Request Cancel By Public User";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      LoadEcardDetails();
    } else if (UpdateInmateConnectionResponse === -5) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Not_Request_Accept_ByPU,
        type: "warning",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "Current Connection Status is Not Request Accept By Public User";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      LoadEcardDetails();
    } else if (UpdateInmateConnectionResponse === -6) {
      dispatch(sendPhotosActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Inmate_Limit_Exceeded,
        type: "warning",
      });
      const infoMessage = "Clicked on Yes option In Redirect into Cancel Connection confirmation Popup";
      const redirectURL = "---";
      const Status = "The Inmate Connection Limit Exceeded ";
      const Response = UpdateInmateConnectionResponse
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    }
  }, [UpdateInmateConnectionResponse]);

  const handleCancelMessage = () => {
    setIsNewPhotoConfirmation(false);
    const infoMessage = "New E-Cards Clicked on NO option";
    const redirectURL = "---";
    const Status = "Hided confirmation Popup"
    const Response = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handleCancelPurchaseHist = () => {
    setIsPurchaseHistoryConfirm(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      ` E-Cards  - Clicked ${"NO"} option In Redirect into Purchase Credit confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  const handleCancelConnection = () => {
    setIsConnectionConfirm(false);
    CreateEventLogTextFileForInbox(
      dispatch,
      `E-Cards  - Clicked ${"NO"} option In Redirect into Cancel Connection confirmation Popup`,
      "---",
      "---",
      "Hided confirmation Popup"
    );
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };
  // Redirect to write message/Photo page
  const handleClickRedirect = () => {
    if (eCardId?.CreditAmount <= 0) {
      setisCreditamountModal(true);
      setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Photo);
    } else if (eCardId?.CreditAmount < eCardId?.FacilityPhotoCost) {
      setisCreditamountModal(true);
      setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Photo);
    } else {
      // Temporaryly commented for Admin side implement the eCard after will enable
      // showLoader();
      // dispatch(
      //   sendPhotosActions.LoadPublicInmateConnectionDet({
      //     userID: UserID,
      //     inmatesID: inmateID,
      //   })
      // );
      // hideLoader();
      const infoMessage = "New E-Cards Clicked on Yes option";
      const redirectURL = "/public/WriteMessage";
      const Status = "Hided confirmation Popup"
      const Response = "---";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      navigate("/public/WriteMessage", {
        state: { EcardInmateID: inmateID },
      });
      storeCurrentRoute("/public/WriteMessage");
    }
  };

  // Redirect to purchase credit page
  const handleClickPurchaseCreditRedirect = () => {
    showLoader();
    dispatch(
      sendPhotosActions.CheckingMsgPhotoStatus({
        addFormData: { UserID: UserID, InmateID: eCardId?.InmateId },
      })
    );
    hideLoader();
  };

  // Back Sent Photos page
  const handleClickPurchaseCredit = (InmateID) => {
    setIsPurchaseHistoryConfirm(true);
    setInmateID(InmateID);
  };

  const handleClickConnection = () => {
    setIsConnectionConfirm(true);
  };

  const handleClickUpdateConnection = () => {
    dispatch(
      sendPhotosActions.UpdateInmateConnection({
        PUIConnectionID: eCardId?.PUIConnectionID,
        UserID: eCardId?.PublicUserId,
        InmatesId: eCardId?.InmateId,
        FacilityID: eCardId?.FacilityId,
        RequestChangeUser: "PublicUser",
        ToConnectionStatusID: "3",
        Action: 0,
        IsSALoginAsPU: 0,
        InmateResidentID: "",
        RelationShip: "",
        InmateInvitePublicUserID: eCardId?.PublicUserId,
      }), // No action for the confirm button
      true, // Show Yes/No buttons
      currentLang?.buttons?.No // Cancel button text
    );
    setIsConnectionConfirm(false);
  };


  return (
    <>
      <ReactNotifications />
      <Container fluid className="p-1" style={{ minHeight: "100vh" }}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="header-title">
            <h5>{currentLang?.EcardHistory}</h5>
          </div>
        </div>
        <div className="card shadow-sm p-3">
          <div className="d-flex align-items-center gap-3">
            <div className="align-items-center">
              {/* Left arrow icon with click handler */}
              <i
                className="fa fa-chevron-left me-2"
                style={{ cursor: "pointer" }}
                onClick={() => handleClickSearch(eCardId?.InmateID, false)}
              ></i>

              {/* Profile icon with redirect link */}
              <Link to="/public/SentE-Cards">
                {/* <div className="profile-icon bg-dark rounded-circle text-white d-flex justify-content-center align-items-center">
                  <i className="bi bi-person fs-4"></i>
                </div> */}
              </Link>
            </div>
            <div>
              <h5 className="mb-0">{eCardId?.Sender == "Inmate" ? eCardId?.MessageFrom : eCardId?.MessageTo}</h5>
              <h6>
                {currentLang?.inbox?.Subject}:{" "}
                <span className="text-muted">{eCardId?.EcardSubject}</span>
              </h6>
            </div>
          </div>
        </div>

        {/* Image and Sidebar Section */}
        <Row className="mt-2 mb-80" style={{ height: "100%" }}>
          <Col className="d-flex align-items-stretch col-12 col-md-12 col-lg-8">
            <div
              className={eCardId?.Envelopecolor ? "card shadow-sm border-radius-all p-3 mb-3 " : "card shadow-sm border-radius-all p-3 mb-3 d-flex justify-content-center align-items-center"}
              style={{
                flex: 1,
                width: "500px",
                height: "500px",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {eCardId?.Envelopecolor ?
                <CustomEcard
                  rotation={rotation}
                  setRotation={setRotation}
                  setLoading={setLoading}
                  imgsrc={imageUrl}
                  isimgrotation={true}
                  showLoader={showLoader}
                  hideLoader={hideLoader}
                  envelopecolor={eCardId?.Envelopecolor} ecardbgcolor={eCardId?.Ecardbgcolor} rippencolor={eCardId?.Rippencolor}
                /> :
                <CustomPhoto
                  rotation={rotation}
                  setRotation={setRotation}
                  setLoading={setLoading}
                  imgsrc={imageUrl}
                  isimgrotation={true}
                  showLoader={showLoader}
                  hideLoader={hideLoader}
                />
              }
            </div>
          </Col>


          <Col className="d-flex col-12 col-md-12 col-lg-4">
            <div
              className="card shadow-sm p-2 mb-3"
              style={{
                height: "auto",
                flex: 1, // Allow this column to stretch and match the height of the image column
              }}
            >
              <div className="text-center mb-4 mt-3 mb-80">
                <strong className="fs-2">{currentLang?.AvailableCredits}</strong>
                <strong
                  className={`fs-2 ${eCardId?.CreditAmount > 0 ? "txt-success" : "text-danger"
                    }`}
                >
                  {" $"}
                  {parseFloat(eCardId?.CreditAmount).toFixed(2)}
                </strong>
              </div>
              <ul className="submenu-list">
                {/* --------------------------------- Menu for New Photos -------------------------------------------------- */}
                <li
                  className={`ActiveSubmenu ${disabledItems["newPhotos"] ? "opacity-50 no-hover" : ""
                    }`}
                  title={
                    disabledItems["newPhotos"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.sentECards?.NewEcards
                  }
                  onClick={
                    !disabledItems["newPhotos"]
                      ? () => handleWriteMessage(eCardId?.InmateId)
                      : undefined
                  }
                >
                  {currentLang?.sentECards?.NewEcards}
                  <label className="pointer float-end">
                    <i class="fa-solid fa-envelope"></i>
                  </label>
                </li>
                {/* --------------------------------- Menu for Photos History -------------------------------------------- */}
                <li
                  className={`ActiveSubmenu ${disabledItems["photosHistory"] ? "opacity-50 no-hover" : ""
                    }`}
                  title={
                    disabledItems["photosHistory"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.sentECards?.EcardHistory
                  }
                  onClick={
                    !disabledItems["photosHistory"]
                      ? () => handleHistoryClick(eCardId?.InmateId, true)
                      : undefined
                  }
                >
                  {currentLang?.sentECards?.EcardHistory}
                  <label className="pointer float-end">
                    <i className="fa fa-archive pointer"></i>
                  </label>
                </li>
                {/* -------------------------------- Menu for Purchase Credits ------------------------------------------------ */}
                <li
                  className={`ActiveSubmenu ${disabledItems["purchaseCredits"]
                    ? "opacity-50 no-hover"
                    : ""
                    }`}
                  title={
                    disabledItems["purchaseCredits"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.inbox?.PurchaseCredits
                  }
                  onClick={
                    !disabledItems["purchaseCredits"]
                      ? () => handleClickPurchaseCredit(eCardId?.InmateId)
                      : undefined
                  }
                >
                  {currentLang?.inbox?.PurchaseCredits}
                  <label className="pointer float-end">
                    <i className="fa fa-shopping-cart pointer"></i>
                  </label>
                </li>
                {/* ------------------------------------ Cancel Connection Menu ------------------------------------------------- */}
                <li
                  className={`ActiveSubmenu ${disabledItems["cancelConnection"]
                    ? "opacity-50 no-hover"
                    : ""
                    }`}
                  title={
                    disabledItems["cancelConnection"]
                      ? currentLang?.tooltip?.permission
                      : currentLang?.inbox?.CancelConnection
                  }
                  onClick={
                    !disabledItems["cancelConnection"]
                      ? handleClickConnection
                      : undefined
                  }
                >
                  {currentLang?.inbox?.CancelConnection}
                  <label className="pointer float-end">
                    <i className="fa fa-times-circle pointer"></i>
                  </label>
                </li>
                {/* ------------------------------------ Print Photo - Menu ------------------------------------------------- */}
                <li
                  className="ActiveSubmenu"
                  title={currentLang?.sentECards?.PrintECard}
                  onClick={handlePrintShow}
                >
                  {currentLang?.sentECards?.PrintECard}
                  <label className="pointer float-end">
                    <i className="fa fa-print pointer"></i>
                  </label>
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Print Section (Hidden by Default) */}

        <div style={{ display: "none" }}>
          <form
            ref={componentRef}
            style={isPrintData ? { display: "block" } : { display: "none" }}
          >
            <div className="container-fluid">
              <div className="w-100">
                <div className="d-flex justify-content-start mb-2">
                  <p className="mb-0">{new Date().toLocaleString()}</p>
                </div>
                <div className="p-4">
                  <h3 className="text-start font-size-20">
                    {currentLang?.EcardPage?.ECARD_CONVERSATION}
                  </h3>
                  <hr />
                  <h5
                    className="text-left"
                    style={{ fontStyle: "italic", fontSize: "15px" }}
                  >
                    {eCard?.PhotoSentDate}
                  </h5>

                  {/* Updated Content Section (Table Concept with 2 Columns) */}
                  <div
                    className="table-responsive"
                    style={{ fontSize: "18px" }}
                  >
                    <table className="table table-bordered">
                      <tbody>
                        {[
                          { label: currentLang?.labels?.From, value: eCardId?.MessageFrom },
                          { label: currentLang?.labels?.To, value: eCardId?.MessageTo },
                          { label: currentLang?.labels?.Subject, value: eCardId?.EcardSubject },
                          {
                            label: currentLang?.labels?.Status_by_Admin,
                            value: eCardId?.EcardActionStatus
                              ? eCardId?.EcardActionStatus
                              : "   -",
                          },
                          {
                            label: currentLang?.labels?.Status_by_Inmate,
                            value: eCardId?.ReadStaus,
                          },
                        ].map((row, index) => (
                          <tr key={index}>
                            <td
                              className="fw-700"
                              style={{
                                width: "30%",
                                paddingRight: "10px",
                                borderRight: "2px solid #ddd",
                              }}
                            >
                              {row.label}
                            </td>
                            {/* Right column without a left border */}
                            <td style={{ width: "70%" }}>{row.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Full Width Image Section */}
              <div className="text-center mt-3">
                <img
                  src={imageUrl}
                  alt="ConversationPhoto"
                  className="img-fluid rounded"
                  style={{
                    width: "100%", // Full width for the photo
                    height: "600px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
            </div>
          </form>
        </div>

        {loader}

        <ConfirmationModal
          show={isNewPhotoConfirmation}
          onHide={handleCancelMessage}
          onConfirm={handleClickRedirect}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.Redirect_Page}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />

        <ConfirmationModal
          show={isPurchaseHistoryConfirm}
          onHide={handleCancelPurchaseHist}
          onConfirm={handleClickPurchaseCreditRedirect}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.Redirect_Page}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />
        <ConfirmationModal
          show={isConnectionConfirm}
          onHide={handleCancelConnection}
          onConfirm={handleClickUpdateConnection}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.Cancel_Connection}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />
        <ConfirmationModal
          show={isPaymentMsg}
          onHide={handlePaymentMsg}
          onConfirm={handlePaymentMsg}
          title={currentLang?.Message}
          message={paymentMsg}
          showCancelButton={false}
          onconfirmname={currentLang?.buttons?.OK}
        />
        {/* Modal Popup for redirect purchase credit */}
        <ConfirmationModal
          show={isCreditamountModal}
          // onHide={handleCancelMessage}
          onConfirm={handleClickRedirectPurchaseridet}
          title={currentLang?.Message}
          message={msgCreditamount}
          showCancelButton={false} // Pass 'false' to hide the "No" button
          messageColor="#FF7F7F"
          size={"lg"}
          onconfirmname={currentLang?.buttons?.Yes}
          closeButton={false}
        />
      </Container>
    </>
  );
};

export default React.memo(EcardViewer);
